// Persists onboarding intent records in browser storage for resumable business onboarding.
import type { OnboardingIntentRecord, OnboardingIntentRepository } from '../core/types';

const STORAGE_KEY = 'sportbook:onboarding-intents';

function readStorage(): OnboardingIntentRecord[] {
  if (typeof window === 'undefined') {
    return [];
  }

  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return [];
  }

  try {
    return JSON.parse(raw) as OnboardingIntentRecord[];
  } catch {
    return [];
  }
}

function writeStorage(records: OnboardingIntentRecord[]): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
}

// Clears guest onboarding drafts so one auth session cannot inherit another session's local intent state.
export function clearLocalStorageOnboardingIntents(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(STORAGE_KEY);
}

export function createLocalStorageOnboardingIntentRepository(): OnboardingIntentRepository {
  return {
    async getAll() {
      return readStorage();
    },
    async saveAll(records: OnboardingIntentRecord[]) {
      writeStorage(records);
    },
    async clearAll() {
      clearLocalStorageOnboardingIntents();
    },
  };
}
